<template>
  <div class="app-wrapper" >
    <v-header :title="app.name"></v-header>
    <sidebar class="sidebar-container" :items="items"></sidebar>
    <div class="content-box" >
      <v-tags></v-tags>
      <div class="content">
        <transition name="fade-transform" mode="out-in">
        <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import vHeader from './Header'
import Sidebar from './Sidebar'
import vTags from './Tags'
import { getApp } from '../../api/app'
import { getPermissions } from '../../api/user'

export default {
  name: 'layout',
  data () {
    return {
      appId: '',
      items: [],
      app: {}
    }
  },
  components: {
    vHeader,
    Sidebar,
    vTags
  },
  watch: {
    '$route' (to, from) {
    }
  },
  beforeRouteEnter (to, from, next) {
    getApp(to.params.id).then(response => {
      next(vm => {
        vm.app = response.data.data
        vm.getAppMenu(to.params.id)
      })
    }).catch(() => {
      next({
        path: '/dashboard'
      })
    })
  },
  methods: {
    getAppMenu (appId) {
      let _this = this
      getPermissions(appId).then(res => {
        _this.items = res.data.data
        // if (res.data.data.length > 0) {
        //
        // } else {
        //   _this.items = [
        //     {
        //       icon: 'ldms-ai-home',
        //       url: '/app/' + appId + '/appDashboard',
        //       menuName: '首页面板'
        //     },
        //     {
        //       icon: 'ldms-heibanblackboard10',
        //       url: '/app/' + appId + '/blackBoard',
        //       menuName: '货源小黑板'
        //     },
        //     {
        //       icon: 'ldms-document',
        //       url: '/app/' + appId + '/receiptList',
        //       menuName: '配货单列表'
        //     }
        //   ]
        // }
      })
    }
  }
}
</script>

<style scoped>
  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
  }
  .app-wrapper:after {
    content: "";
    display: table;
    clear: both;
  }
  .content-box {
    position: absolute;
    left: 180px;
    right: 0;
    top: 70px;
    bottom: 0;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f0f0f0;
  }
  .content {
    width: auto;
    padding: 40px;
  }

</style>
